import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    minHeight: 200
  },
  spinnerBox: {
    display: 'flex',
    justifyContent: 'center'
  },
  formControl: {
    margin: theme.spacing(1)
  },
  mt1: {
    marginTop: theme.spacing(1)
  },
  mt3: {
    marginTop: theme.spacing(3)
  }
}));
